<template>
  <span
    class="ProgressCell"
    :class="[
      theme,
      isClickable ? 'clickable' : '',
      isFlexible ? 'flexible' : '',
    ]"
    @click="click"
    @keypress.enter="click">
    <span v-if="isLoading">
      <Loader class="sm" />
    </span>
    <Pic
      v-else-if="imageUrl"
      :src="imageUrl" />
    <template v-else>
      <span class="label">
        <Icon v-if="icon" :name="icon" />
        {{ label }}
      </span>
      <Icon
        v-if="subIcon"
        class="subIcon"
        :name="subIcon" />
    </template>
  </span>
</template>

<script>
import { getters } from '@utils'

export default {
  props: {
    icon: { type: String, default: null },
    imageFileId: { type: Number, default: null },
    isClickable: { type: Boolean, default: true },
    isFlexible: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    label: { type: String, default: null },
    subIcon: { type: String, default: null },
    theme: { type: String, default: 'neutral' },
  },
  computed: {
    imageUrl() {
      const { imageFileId } = this

      if (!imageFileId) return

      const file = this.queryOne('file', imageFileId)

      if (!file) return

      return this.getFileUrl(file)
    },
    ...getters('getFileUrl'),
  },
  methods: {
    click() {
      if (!this.isClickable) return

      this.$emit('click')
    },
  },
}
</script>

<style lang="scss">
$_size: $grid-unit * 1.5;

.ProgressCell {
  @include trans;
  align-items: center;
  display: inline-flex;
  flex-grow: 1;
  height: $_size;
  justify-content: center;
  opacity: 0.75;
  position: relative;
  vertical-align: bottom;
  width: $_size;

  > .label {
    font-size: $h5;
  }

  > .Pic {
    display: inline-block;
    height: $_size;
    overflow: hidden;
    width: $_size;

    > img {
      display: block;
      height: 110%;
    }
  }

  > .subIcon {
    bottom: 0;
    font-size: $h7;
    position: absolute;
    right: 0;
  }

  &.danger {
    background: $danger;
    color: $danger-darker;
    font-weight: $semibold;

    > .subIcon {
      color: $danger-lighter;
    }
  }

  &.info {
    background: $info;
    color: $info-darker;
    font-weight: $semibold;

    > .subIcon {
      color: $info-lighter;
    }
  }

  &.success {
    background: $success;
    color: $success-darker;
    font-weight: $semibold;

    > .subIcon {
      color: $success-lighter;
    }
  }

  &.warning {
    background: $warning;
    color: $warning-darker;
    font-weight: $semibold;

    > .subIcon {
      color: $warning-lighter;
    }
  }

  &.clickable {
    cursor: pointer;

    &:hover {
      opacity: 1;
    }
  }

  &.flexible {
    width: 100%;
  }
}
</style>
